export const affiliates = {
  klm: "KLM",
  transavia: "TRANSAVIA",
};
